import { Country, ScrubAddressPayload } from '@buy-viasat/types/build/bv';
import { AddressFieldStateType, defaultAddressData, defaultAddressForm, LocationType } from '../address';
import { ApolloQueryResult, gql } from '@apollo/client';

export type ServiceabilityState = {
  isServiceabilityLoading: boolean;
  latitude: number | null;
  longitude: number | null;
  scrubbedLocation: LocationType;
  serviceAddress: AddressFieldStateType;
  showMap: boolean;
  useScrubbedAddress: boolean;
  isServiceAddressSet: boolean;
  hasFiberMduAddress: boolean;
  fiberMultipleAddressesForPreviewProducts: boolean;
  // The exact addressLines scrubAddress returned, forwarded verbatim to downstream providers.
  unsanitizedAddressLines: string[] | null;
};

export const initialServiceabilityState: ServiceabilityState = {
  isServiceabilityLoading: true,
  latitude: null,
  longitude: null,
  scrubbedLocation: {
    address: defaultAddressData(Country.US),
    coordinates: {
      latitude: null,
      longitude: null,
    },
  },
  serviceAddress: defaultAddressForm(Country.US),
  showMap: false,
  useScrubbedAddress: true,
  isServiceAddressSet: false,
  hasFiberMduAddress: false,
  fiberMultipleAddressesForPreviewProducts: false,
  unsanitizedAddressLines: null,
};

export enum ThunkActions {
  scrubAddress = 'scrubAddress',
}

export const SCRUB_ADDRESS = gql`
  query scrubAddress($input: ScrubAddressInput!) {
    scrubAddress(input: $input) {
      addressLines
      municipality
      region
      countryCode
      postalCode
      longitude
      latitude
      bannedPostalCode
      invalidAddress
      processStatus
      recommendation
      hasFiberMduAddress
    }
  }
`;

export type ScrubAddressWithCoordinatesPayload = ApolloQueryResult<{ scrubAddress: ScrubAddressPayload }>;
